import { render, staticRenderFns } from "./AzurePermissionDisabledDialog.vue?vue&type=template&id=106ac17c&scoped=true"
import script from "./AzurePermissionDisabledDialog.vue?vue&type=script&lang=js"
export * from "./AzurePermissionDisabledDialog.vue?vue&type=script&lang=js"
import style0 from "./AzurePermissionDisabledDialog.vue?vue&type=style&index=0&id=106ac17c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106ac17c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('106ac17c')) {
      api.createRecord('106ac17c', component.options)
    } else {
      api.reload('106ac17c', component.options)
    }
    module.hot.accept("./AzurePermissionDisabledDialog.vue?vue&type=template&id=106ac17c&scoped=true", function () {
      api.rerender('106ac17c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AzurePermissionDisabledDialog.vue"
export default component.exports